import { Outlet, createFileRoute, redirect } from '@tanstack/react-router';

import { meQueryOptions } from '@/hooks/data/use-auth';
import { hasSeenPaywall } from '@/lib/paywall-seen';
import { getRedirectPath } from '@/lib/routes';

export const Route = createFileRoute('/_public')({
  beforeLoad: async ({ context, location }) => {
    const user = await context.queryClient
      .fetchQuery(meQueryOptions)
      .catch(() => null);

    const target = getRedirectPath({
      pathname: location.pathname,
      user,
      paywallSeen: hasSeenPaywall(user?.organization_id),
    });
    if (target) {
      // TanStack Router uses thrown non-Error redirects as control flow.
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({ to: target, replace: true });
    }
  },
  component: () => <Outlet />,
});
